export default {
    common: {
        title: 'Content AI',
        socialPlanner: 'Social Planner',
        blog: 'Blog',
        funnel: 'Funnel',
        website: 'Website',
        mediaLibrary: 'Media Library',
        email: 'Email',
        words: 'Words',
        variations: 'Variations',
        thisIsPaidService: 'This feature is a paid service and will incur charges based on your usage.',
        all: 'All',
    },
};
